//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/MBD.js";
import "../no/Object.js";
import "../no/Rule.js";
import "../no/Session.js";
let d=[[],[[["part"],"CreateWebRuleLibraryBuilder",{R_:{builder:"MBD.WebRuleLibraryBuilder"}},1,0],[["part","ruleInstance"],"CreateWebRuleInstanceBuilderFromRuleInstance",{R_:{builder:"MBD.WebRuleInstanceBuilder"}},2,0],[["part","libraryRule"],"CreateWebRuleInstanceBuilderFromLibraryRule",{R_:{builder:"MBD.WebRuleInstanceBuilder"}},2,0],[["json"],"UpdateCloudRuleLibraryFromJson",{},1,0]],[]];
SPLM.MBD.WebRuleManager = class extends SPLM.Object{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.MBD.WebRuleManager";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;